module.exports = __webpack_public_path__ + "static/media/caros-thin-italic.6b7d01e1.woff2";